/*
function ajax_workshops(str){     

var email_field=$("#optin_request").val();
   
var source='partner';

var sParam='lnid';
var valuelabel=GetURLParameter(sParam);
var _this=this;   
var email_field=$("#optin_request").val();
var name_field=$("#optin_request_name").val();
var company_field=$("#optin_request_company").val();
var phone_field=$("#optin_request_phone").val();
var twitter_field=$("#optin_request_twitter").val();
var comments_field=$("#optin_request_comments").val();
var landing_url=$("#landing_url").val();


var name_field=encodeURI(name_field);
var company_field=encodeURI(company_field);
var phone_field=encodeURI(phone_field);
var twitter_field=encodeURI(twitter_field);
var comments_field=encodeURI(comments_field);


var optin_request_name=encodeURI($("#optin_request_name").val());
var optin_request=encodeURI($("#optin_request").val());
var optin_request_company=encodeURI($("#optin_request_company").val());
var optin_date=encodeURI($("#optin_date").val());
var optin_first_position=encodeURI($("#optin_first_position").val());
var optin_request_phone=encodeURI($("#optin_request_phone").val());
var optin_event=encodeURI($("#optin_event").val());
var optin_participants=encodeURI($("#optin_participants").val());
var optin_request_twitter=encodeURI($("#optin_request_twitter").val());
var optin_request_comments=encodeURI($("#optin_request_comments").val());
var landing_url=encodeURI($("#landing_url").val());
var utm_source_partner=encodeURI($("#utm_source_partner").val());
var utm_medium_partner=encodeURI($("#utm_medium_partner").val());
var utm_content_partner=encodeURI($("#utm_content_partner").val());
var optin_request_position=encodeURI($("#optin_request_position").val());
var emailzer= $("#optin_request").val();
 


  

  
var date_field=$("#optin_date").val();
var event_field=$("#optin_event").val();
var position_field=$("#optin_request_position").val();
var participants_field=$("#optin_participants").val();
  
email_field = email_field.replace(/ /g, "");

document.getElementById("optin_request").value=email_field;  

var email_field=encodeURI(email_field);
  
var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
 if(email_field.match(mailformat))
 {

if(name_field && date_field  && event_field  &&  position_field &&  participants_field && comments_field ){

  
// document.getElementById("make_partner").submit();

    $("#custom_form").html("<center><p style='font-size:80%;'> <strong>Thanks for applying! We will be contacting you back in the next day or two.</strong> </p></center>");

 const xhttp = new XMLHttpRequest();
  xhttp.onload = function() {

   

if ((optin_request_position == 'Coach' || optin_request_position == 'Consultant' || optin_request_position == 'Administration') && (Number(optin_participants) > 25 )){

//console.log('approved event');
window.location.href = "https://wipebook.com/collections/workshop-donation?approved="+emailzer;
     
  }else{
 
    $("#custom_form").html("<center><p style='font-size:80%;'> <strong>Thanks for applying! We will be contacting you back in the next day or two.</strong> </p></center>");
    ;
  
  }

    
    console.log(xhttp.responseText);
  }
  xhttp.open("POST", "https://hook.us1.make.com/6xj5tl14bzylopvgms2x9suosevhf7j1");
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.send("optin_request_name="+optin_request_name+"&optin_request="+optin_request+"&optin_request_company="+optin_request_company+"&optin_date="+optin_date+"&optin_first_position="+optin_first_position+"&optin_request_phone="+optin_request_phone+"&optin_event="+optin_event+"&optin_participants="+optin_participants+"&optin_request_twitter="+optin_request_twitter+"&optin_request_comments="+optin_request_comments+"&landing_url="+landing_url+"&utm_source_partner="+utm_source_partner+"&utm_medium_partner="+utm_medium_partner+"&utm_content_partner="+utm_content_partner+"&optin_request_position="+optin_request_position
);
  


    
  
}  else{

console.log();
  
 $("#custom_form_error").html("<center><p style='font-size:80%;'> <strong>Please complete the missing fields. </strong> </p></center>");
  
}

        }else{

            $("#custom_form_error").html("<center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center>");
         
            
         }
        
        

        }	
	
	*/


function isValidDateFormat(dateStr) {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  return regex.test(dateStr);
}


function ajax_workshops(str){     

var email_field=$("#optin_request").val();
   
var source='partner';

var sParam='lnid';
var valuelabel=GetURLParameter(sParam);
var _this=this;   
var email_field=$("#optin_request").val();
var name_field=$("#optin_request_name").val();
var company_field=$("#optin_request_company").val();
var phone_field=$("#optin_request_phone").val();
var twitter_field=$("#optin_request_twitter").val();
var comments_field=$("#optin_request_comments").val();
var landing_url=$("#landing_url").val();


var name_field=encodeURI(name_field);
var company_field=encodeURI(company_field);
var phone_field=encodeURI(phone_field);
var twitter_field=encodeURI(twitter_field);
var comments_field=encodeURI(comments_field);


var optin_request_name=encodeURI($("#optin_request_name").val());
var optin_request=encodeURI($("#optin_request").val());
var optin_request_company=encodeURI($("#optin_request_company").val());
var optin_date=encodeURI($("#optin_date").val());
var optin_first_position=encodeURI($("#optin_first_position").val());
var optin_request_phone=encodeURI($("#optin_request_phone").val());
var optin_event=encodeURI($("#optin_event").val());
var optin_participants=encodeURI($("#optin_participants").val());
var optin_request_twitter=encodeURI($("#optin_request_twitter").val());
var optin_request_comments=encodeURI($("#optin_request_comments").val());
var landing_url=encodeURI($("#landing_url").val());
var utm_source_partner=encodeURI($("#utm_source_partner").val());
var utm_medium_partner=encodeURI($("#utm_medium_partner").val());
var utm_content_partner=encodeURI($("#utm_content_partner").val());
var optin_request_position=encodeURI($("#optin_request_position").val());
var emailzer= $("#optin_request").val();
 


  

  
var date_field=$("#optin_date").val();
var event_field=$("#optin_event").val();
var position_field=$("#optin_request_position").val();
var participants_field=$("#optin_participants").val();
  
email_field = email_field.replace(/ /g, "");

document.getElementById("optin_request").value=email_field;  

var email_field=encodeURI(email_field);
  
var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;


if (isValidDateFormat(optin_date)){
  
 if(email_field.match(mailformat))
 {

if(name_field && date_field  && event_field  &&  position_field &&  participants_field && comments_field ){

  
// document.getElementById("make_partner").submit();

    $("#custom_form").html("<center><p style='font-size:80%;'> <strong>Thanks for applying! We will be contacting you back in the next day or two.</strong> </p></center>");

 const xhttp = new XMLHttpRequest();
  xhttp.onload = function() {

   

if ((optin_request_position == 'Coach' || optin_request_position == 'Consultant' || optin_request_position == 'Administration') && (Number(optin_participants) > 25 )){

//console.log('approved event');
window.location.href = "https://wipebook.com/collections/workshop-donation?approved="+emailzer;
     
  }else{
 
    $("#custom_form").html("<center><p style='font-size:80%;'> <strong>Thanks for applying! We will be contacting you back in the next day or two.</strong> </p></center>");
    ;
  
  }

    
    console.log(xhttp.responseText);
  }
  xhttp.open("POST", "https://hook.us1.make.com/6xj5tl14bzylopvgms2x9suosevhf7j1");
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.send("optin_request_name="+optin_request_name+"&optin_request="+optin_request+"&optin_request_company="+optin_request_company+"&optin_date="+optin_date+"&optin_first_position="+optin_first_position+"&optin_request_phone="+optin_request_phone+"&optin_event="+optin_event+"&optin_participants="+optin_participants+"&optin_request_twitter="+optin_request_twitter+"&optin_request_comments="+optin_request_comments+"&landing_url="+landing_url+"&utm_source_partner="+utm_source_partner+"&utm_medium_partner="+utm_medium_partner+"&utm_content_partner="+utm_content_partner+"&optin_request_position="+optin_request_position
);
  


    
  
}  else{

console.log();
  
 $("#custom_form_error").html("<center><p style='font-size:80%;'> <strong>Please complete the missing fields. </strong> </p></center>");
  
}

        }else{

            $("#custom_form_error").html("<center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center>");
         
            
         }
        
}else{

 
            $("#custom_form_error").html("<center><p style='font-size:80%;'> <strong>There is an issue with your date format.</strong> </p></center>");
          
}

        }	
	
	












function ajax_quote(str10){  

    $( "#loading" ).show();
    
    $.fn.serializeObject = function()
    {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        
        return o;
    };
    
    var email_field=$("#email").val();
    var phone_number_field=$("#phone_number").val();

   var country_field_shipping=$("#country_shipping").val();
  var organization_field_shipping=$("#organization_shipping").val();
  var firstname_field_shipping=$("#first-name_shipping").val();
  var lastname_field_shipping=$("#last-name_shipping").val();
  var position_field_shipping=$("#position_shipping").val();
  var address1_field_shipping=$("#address1_shipping").val();
  var city_field_shipping=$("#city_shipping").val();
  var province_field_shipping=$("#province_shipping").val();
  var postal_field_shipping=$("#postal_shipping").val();

  var country_field=$("#country").val();
  var organization_field=$("#organization").val();
  var firstname_field=$("#first-name").val();
  var lastname_field=$("#last-name").val();
  var position_field=$("#position").val();
  var address1_field=$("#address1").val();
  var city_field=$("#city").val();
  var province_field=$("#province").val();
  var postal_field=$("#postal").val();
    //alert('winballws');
		//alert('byebye');
   
    var draft_form_elements=($('form').serializeObject());

//console.log(draft_form_elements['collection_id']);


var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
 if(email_field.match(mailformat))
 {

  if( (phone_number_field) &&(country_field) && (organization_field) && (firstname_field) && (lastname_field) && (position_field) && (address1_field) && (city_field) && (province_field) && (postal_field) && (country_field_shipping) && (organization_field_shipping) && (firstname_field_shipping) && (lastname_field_shipping) && (position_field_shipping) && (address1_field_shipping) && (city_field_shipping) && (province_field_shipping) && (postal_field_shipping) )
 { 
   console.log('no missing fields');
// { firstName: 'Jean-Luc', lastName: 'Picard' }
const filtered_array=Object.fromEntries(Object.entries(draft_form_elements).filter(([key]) => key.includes('_item')));

const unique_array=Object.fromEntries(Object.entries(draft_form_elements).filter(([key]) => key.includes('id_item')));

//console.log(unique_array);

const line_items = [];
var counter = 0;
var order_weight=0;
for (const [key, value] of Object.entries(unique_array)) {

    var keyloop = key;
    var key_quantity_item = value+'_quantity_item';
    var key_id_item = value+'_quantity_item';
    var key_discounted_item = value+'_discounted_item';
    var key_msrp_item = value+'_msrp_item';
    var key_weight_item = value+'_weight_item';
    var amount = filtered_array[key_discounted_item]*filtered_array[key_quantity_item];
    var off = filtered_array[key_msrp_item]-filtered_array[key_discounted_item];


    if (filtered_array[key_quantity_item] > 0){

    if (keyloop.includes("_quantity_item")){ var quantity_item = value; }else{var quantity_item = 0;}
    if (keyloop.includes("_id_item")){ var id_item = value; }else{var id_item = 0;}
    if (keyloop.includes("_discount_item")){ var discount_item = value; }else{var discount_item = 0;}
    if (keyloop.includes("_discount_item")){ var discount_item = value; }else{var discount_item = 0;}
    if (keyloop.includes("_discount_item")){ var discount_item = value; }else{var discount_item = 0;}

    const item = {"variant_id":id_item,"quantity":filtered_array[key_quantity_item],"applied_discount":{"description":"Volume Discount","value_type":"fixed_amount","value":off,"amount":amount,"title":"Volume"}};
    
    order_weight=(filtered_array[key_quantity_item]*filtered_array[key_weight_item])+order_weight;


    line_items[counter]=item;

    counter=counter+1;
    }

    }
  
    var line_items_send;

    line_items_send='{"line_items":'+JSON.stringify(line_items)+'}';

    document.getElementById('line_items').value=line_items_send;
    document.getElementById('ship').value=Math.round(100*(12+(2.3*order_weight)))/100;
    console.log(line_items);
    console.log(order_weight+'lbs');
    document.getElementById("submit_form").submit();
   
    setTimeout(() => { 
    window.scrollTo(0, 0);	
								
    $('#ordering_space').html('');

    $('#description_text').html('<h2>Quotes for companies and educational institutions:</h2><br>Thank you for the request. Your quote  has been sent to our team and they should be sending you an email confirmation within the next day. If you have any questions, feel free to touch base with us at support@wipebook.com.<br><br><h2>Has your company or school board/district ordered before?</h2>If you are a new customer looking to provide a payment via a PO, please complete this additional form in order to confirm the required billing information:<br><br><a class="btn btn--fill btn--regular btn--color" style=" box-sizing: border-box; font-size: 14px; color: #fff; text-decoration: none; line-height: 2em; font-weight: bold; text-align: center; cursor: pointer; display: inline-block; border-radius: 5px; background-color: #019fe9; margin: 0; border-color: #019FE9; border-style: solid; border-width: 10px 0px;" href="https://forms.gle/eytTwVrzj3gWGuLk9" target="_blank" >Submit additional billing information</a><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>'); 
}, 1000);	

 }else{
 $( "#loading" ).hide();
    $('#result').html("<center><p style='font-size:80%;'> <strong>One of the fields is missing information. Please complete missing information.</strong> </p></center>");
   
 }



   
}else{
    $( "#loading" ).hide();
    $('#result').html("<center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center>");
}
    
    
    }





function ajax_province_shipping(str,str2){     


var url='https://wipebook.org/shopify/forms/country_shipping.php';
//var url='https://wipebook.co/mail/country_shipping.php';
var datastring=str;


var dropdown_us='<select style="width:200px;" id="province_shipping" name="province_shipping" class="input-xlarge" placeholder="State / Province / Region"><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option> <option value="AS">American Samoa</option><option value="GU">Guam</option><option value="MP">Northern Mariana Islands</option><option value="PR">Puerto Rico</option><option value="UM">United States Minor Outlying Islands</option><option value="VI">Virgin Islands</option><option value="AA">Armed Forces Americas</option><option value="AP">Armed Forces Pacific</option><option value="AE">Armed Forces Others</option></select>';
var dropdown_other='<input type="text" id="province" name="province_shipping" class="input-xlarge" placeholder="State / Province / Region">';
var dropdown_ca='<select style="width:200px;" id="province_shipping" name="province_shipping" class="input-xlarge" placeholder="State / Province / Region"><option value="AB">alberta</option><option value="BC">british columbia</option><option value="MB">manitoba</option><option value="NB">new brunswick</option><option value="NL">newfoundland and labrador</option><option value="NS">nova scotia</option><option value="NT">northwest territories</option><option value="NU">nunavut</option><option value="ON" selected="">ontario</option><option value="PE">prince edward island</option><option value="QC">quebec</option><option value="SK">saskatchewan</option><option value="YT">yukon</option></select>';

if (str == 'CA'){ document.getElementById("province_field_shipping").innerHTML=dropdown_ca; }

if (str == 'US'){ document.getElementById("province_field_shipping").innerHTML=dropdown_us; }

  if ((str != 'US') && (str != 'CA')) {
document.getElementById("province_field_shipping").innerHTML=dropdown_other;
  }

if (typeof str2 !== "undefined"){
document.getElementById('province_shipping').value=str2;
}  
  /*
$.ajax({
                type: "POST", url:url,
				contentType: "text",
                crossDomain:true, dataType:"text",
				data: datastring,
                success: function (data, status, jqXHR) {
					
                 //  alert('yumyum'+data);
                 // getData();
				var obj = JSON.stringify(data);
				//$('#result').text(obj + '*');	
				
				//$('#result').text(data);
				$('#province_field_shipping').html(data);
				
				if (typeof str2 !== "undefined"){
				document.getElementById('province_shipping').value=str2;
				}
				//alert(data);
				//window.location.href = "https://wipebook.com/collections/" + data;
				 // return(true); 
                },
                error: function (jqXHR, status, error) {
                    
					 $('#result').text(jqXHR.responseText+" error " + status);
					
					//alert(jqXHR.responseText+"errorrr" + status);   
			
                }
            }); 

		*/

/*


if (str == 'US'){
$('#province_div').html('<input id="province" name="province" type="text" placeholder="State" class="input-xlarge" />');
}else{
	
	if (str == 'CA'){
		$('#province_div').html('<input id="province" name="province" type="text" placeholder="Province" class="input-xlarge" />');
	}else{
		$('#province_div').html('<input id="province" name="province" type="text" placeholder="Region" class="input-xlarge" />');
		}
	
	}
*/


}


 

function ajax_province(str){     


var url='https://wipebook.org/shopify/forms/country_social.php';	
//var url='https://wipebook.co/mail/country_social.php';
var datastring=str;

var dropdown_us='<select style="width:200px;" id="province" name="province" class="input-xlarge" placeholder="State / Province / Region" onchange="autofill();"><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option> <option value="AS">American Samoa</option><option value="GU">Guam</option><option value="MP">Northern Mariana Islands</option><option value="PR">Puerto Rico</option><option value="UM">United States Minor Outlying Islands</option><option value="VI">Virgin Islands</option><option value="AA">Armed Forces Americas</option><option value="AP">Armed Forces Pacific</option><option value="AE">Armed Forces Others</option></select>';
var dropdown_other='<input type="text" id="province" name="province" class="input-xlarge" placeholder="State / Province / Region" onchange="autofill();">';
var dropdown_ca='<select style="width:200px;" id="province" name="province" class="input-xlarge" placeholder="State / Province / Region" onchange="autofill();"><option value="AB">alberta</option><option value="BC">british columbia</option><option value="MB">manitoba</option><option value="NB">new brunswick</option><option value="NL">newfoundland and labrador</option><option value="NS">nova scotia</option><option value="NT">northwest territories</option><option value="NU">nunavut</option><option value="ON" selected="">ontario</option><option value="PE">prince edward island</option><option value="QC">quebec</option><option value="SK">saskatchewan</option><option value="YT">yukon</option></select>';

if (str == 'CA'){ document.getElementById("province_field").innerHTML=dropdown_ca; }

if (str == 'US'){ document.getElementById("province_field").innerHTML=dropdown_us; }

  if ((str != 'US') && (str != 'CA')) {
document.getElementById("province_field").innerHTML=dropdown_other;
  }
  /*
  
$.ajax({
                type: "POST", url:url,
				contentType: "text",
                crossDomain:true, dataType:"text",
				data: datastring,
                success: function (data, status, jqXHR) {
					
                 //  alert('yumyum'+data);
                 // getData();
				var obj = JSON.stringify(data);
				//$('#result').text(obj + '*');	
				
				//$('#result').text(data);
				$('#province_field').html(data);
				//alert(data);
				//window.location.href = "https://wipebook.com/collections/" + data;
				   
                },
                error: function (jqXHR, status, error) {
                    
					 $('#result').text(jqXHR.responseText+" error " + status);
					
					//alert(jqXHR.responseText+"errorrr" + status);   
			
                }
            }); 

	*/	

/*


if (str == 'US'){
$('#province_div').html('<input id="province" name="province" type="text" placeholder="State" class="input-xlarge" />');
}else{
	
	if (str == 'CA'){
		$('#province_div').html('<input id="province" name="province" type="text" placeholder="Province" class="input-xlarge" />');
	}else{
		$('#province_div').html('<input id="province" name="province" type="text" placeholder="Region" class="input-xlarge" />');
		}
	
	}
*/


}


function ajax_partner(str){     

    var email_field=$("#optin_request").val();
   

var source='partner';

var sParam='lnid';
var valuelabel=GetURLParameter(sParam);
var _this=this;   
var email_field=$("#optin_request").val();
var name_field=$("#optin_request_name").val();
var company_field=$("#optin_request_company").val();
var phone_field=$("#optin_request_phone").val();
var twitter_field=$("#optin_request_twitter").val();
var comments_field=$("#optin_request_comments").val();
var landing_url=$("#landing_url").val();


var email_field=encodeURI(email_field);
var name_field=encodeURI(name_field);
var company_field=encodeURI(company_field);
var phone_field=encodeURI(phone_field);
var twitter_field=encodeURI(twitter_field);
var comments_field=encodeURI(comments_field);


var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
 if(email_field.match(mailformat))
 {

    
    document.getElementById("make_partner").submit();
    
    $("#custom_form").html("<center><p style='font-size:80%;'> <strong>Thanks for applying! We will be contacting you back in the next day or two.</strong> </p></center>");
 


        }else{

            $("#custom_form").html("<center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center>");
         
            
         }
        
        

}	

		
function ajax_out(str){     

    var email_field=$("#optin_request").val();

if (email_field){
document.getElementById("make").submit();
}

var source=str;
var _this=this;   

var product_field=$("#product_field").val();
var coupon_email=$("#coupon_email").val();
var landing_url=encodeURIComponent($("#landing_url_pop").val());  

var url="https://wipebook.org/customers/add_email.php?source="+ source +"&email="+email_field+"&coupon="+coupon_email+"&landing_url="+landing_url+"&product_id=" + product_field;



//alert('secret passage way');

 $("#custom_form_out").html("<img style='width:30px;' src='https://cdn.shopify.com/s/files/1/0883/6332/files/loading.gif?11508027098045112438'> <span id='custom_form_error_out'></span>");


 var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
 if(email_field.match(mailformat))
 {
 //console.log("Valid email address!");
 
 $("#custom_form_out").html("<center><p style='font-size:80%;'> Perfect, we will forward the information to <strong>"+ email_field +"</strong>. </p></center><br>");



        }else{

            $("#custom_form_out").html(" <center> <p style='font-size:80%;'>There was an error in your email format.  Refresh and try again.</p></center>");


        }
        
       

        }	



function ajax_contest(){  

alert('This contest link is expired. For further support, please contact support@wipebook.com. You will be redirected to our general weekly contest link for your chance to win.');
window.location.href = "https://wipebook.com/contest";
}

		
function ajax_edu(str){     

alert('This form no longer exists, please contact support@wipebook.com. You will be redirected to our general education information page.');
window.location.href = "https://wipebook.com/quotes";     

}	

		
function ajax_coupon(){        

alert('This form no longer exists, please contact support@wipebook.com. You will be redirected to our general discount page.');
window.location.href = "https://wipebook.com/?coupon=20";     
		
}
   

